import { KalturaProgramAsset } from '../../objects';
import { fetchAsset } from '../../services';

import { processProgram } from './processProgram';

type FetchProgramArgs = {
  id: string;
};

export async function fetchProgram({ id }: FetchProgramArgs) {
  const data = await fetchAsset<KalturaProgramAsset>({ assetReferenceType: 'epg_internal', id });

  return processProgram(data);
}
